import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Components
import { BranchesComponent } from './components/branches/branches.component';
import { CartComponent } from './components/cart/cart.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaymentComponent } from './components/payment/payment.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SaleHistoryComponent } from './components/sale-history/sale-history.component';
import { StoreComponent } from './components/store/store.component';
import { BaseComponent } from './components/base/base.component';
import { LogedGuard } from './guards/loged.guard';
import { PayGuard } from './guards/pay.guard';
import { RedirectStoreComponent } from './components/redirect-store/redirect-store.component';
import { PromotionsComponent } from './components/promotions/promotions.component';
import { FamiliarsComponent } from './components/familiars/familiars.component';
import { DirectionsComponent } from './components/directions/directions.component';
import { PromoT1Component } from './components/promo-t1/promo-t1.component';
import { PromoT2Component } from './components/promo-t2/promo-t2.component';
import { PromoT3Component } from './components/promo-t3/promo-t3.component';
import { PromoT4Component } from './components/promo-t4/promo-t4.component';
import { PromoT5Component } from './components/promo-t5/promo-t5.component';
import { PromoT6Component } from './components/promo-t6/promo-t6.component';
import { AccessGuard } from './guards/access.guard';
import { AccessComponent } from './core-components/access/access.component';

const routes: Routes = [
  { path: 'access', component: AccessComponent },
  { path:'', component:BaseComponent, canActivate:[AccessGuard], children:[
    {path:'branches', component:BranchesComponent, canActivate:[]},
    {path:'cart', component:CartComponent, canActivate:[]},
    {path:'coupons', component:CouponsComponent, canActivate:[LogedGuard]},
    {path:'home', component:HomeComponent, canActivate:[]},
    {path:'payment', component:PaymentComponent, canActivate:[PayGuard]},
    {path:'profile', component:ProfileComponent, canActivate: [LogedGuard]},
    {path:'history', component:SaleHistoryComponent, canActivate:[LogedGuard]},
    {path:'store', component:StoreComponent, canActivate:[]},
    {path:'promotions', component:PromotionsComponent, canActivate:[]},
    {path:'family', component:FamiliarsComponent, canActivate:[LogedGuard]},
    {path:'addresses', component:DirectionsComponent, canActivate:[LogedGuard]},
    {path:'promo1', component:PromoT1Component, canActivate:[LogedGuard]},
    {path:'promo2', component:PromoT2Component, canActivate:[LogedGuard]},
    {path:'promo3', component:PromoT3Component, canActivate:[LogedGuard]},
    {path:'promo4', component:PromoT4Component, canActivate:[LogedGuard]},
    {path:'promo5', component:PromoT5Component, canActivate:[LogedGuard]},
    {path:'promo6', component:PromoT6Component, canActivate:[LogedGuard]},
  ]},
  {path:'qr', component:RedirectStoreComponent, canActivate:[]},
  {path:'**', component:NotFoundComponent, canActivate:[]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
